import React from "react";
import Slider from "react-slick";

const ClientsCarousel = () => {
  const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 8,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 1000,
  arrows: false,   // <-- BEST way to hide arrows
};

  return (
    <div style={{ width: "100%"}}>
      <Slider {...settings} className='client-slider'>
        <div className="client-card">
          <img src='assets/img/OurClients/Client1.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client2.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client3.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client4.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client5.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client6.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client7.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client8.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client9.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client10.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client11.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client12.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client13.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client14.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client15.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client16.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client17.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client18.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client19.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client20.jpeg' className='client-img'/>
        </div>
        <div className="client-card">
          <img src='assets/img/OurClients/Client21.jpeg' className='client-img'/>
        </div>
      </Slider>
    </div>
  );
};

export default ClientsCarousel;
